export class Utils {
	static clone(o: any) {
		return JSON.parse(JSON.stringify(o));
	}
}
